import { api } from '@/services'

export function findAll(params) {
  return api.get('/admin/charge/list', { params })
}
